import { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalSubHeading,
    ModalHeading,
    ModalHeader,
} from "../../Styles/InputStyles";
import { MdClose, MdArrowBack } from "react-icons/md";
import tw from "tailwind-styled-components";
import { useSelector } from "react-redux";
import {
    Select,
    MenuItem,
} from "@mui/material";
import { ErrorText } from "../../Styles/PageStyles";

// Step 1 Schema
const stepSchema = Yup.object().shape({
    maxTransactionLimit: Yup.number()
        .required("Maximum transaction limit is required")
        .typeError("Enter a valid amount")
        .min(1, "Transaction limit must be greater than 0"),

    // dailyLimit: Yup.number()
    //     .required("Daily limit is required")
    //     .typeError("Enter a valid amount")
    //     .min(1, "Daily limit must be greater than 0"),
});


const Edit = ({ editStaffWalletMutate, editStaffWalletLoading, handleClose, selectedData }) => {
    const [height, setHeight] = useState(window.innerHeight);
    const [currentStep, setCurrentStep] = useState(1);
    const [step1Data, setStep1Data] = useState(null);

    // Initial values for step 1
    const initialValuesStep = {
        name: selectedData?.name || "",
        maxTransactionLimit: selectedData?.maxTransLimit || 0,
        //dailyLimit: selectedData?.dailyLimit || 0,
    };


    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSubmit = (values) => {

        editStaffWalletMutate({
            staffId: selectedData.staffId,
            maxTransactionLimit: Number(values.maxTransactionLimit),
            dailyLimit: 0,
        });
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">
                    Edit Staff Wallet
                </h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>


            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValuesStep}
                    onSubmit={handleSubmit}
                    validationSchema={stepSchema}
                    enableReinitialize
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-180px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="mobile">Staff Name*</Label>
                                        <FieldWrappers className="bg-gray-100">
                                            <Field
                                                type="text"
                                                name="name"
                                                id="name"
                                                autoComplete="off"
                                                maxLength={10}
                                                disabled={true}
                                            />
                                        </FieldWrappers>
                                        {errors.name && touched.name && (
                                            <ErrorMessage>{errors.name}</ErrorMessage>
                                        )}
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="mobileNo">Maximum Transaction Limit *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="tel"
                                                name="maxTransactionLimit"
                                                id="maxTransactionLimit"
                                                autoComplete="off"
                                                maxLength="10"
                                                placeholder="Enter maximum transaction limit"
                                                className={errors.maxTransactionLimit && touched.maxTransactionLimit ? "border-red-500" : ""}
                                            />
                                        </FieldWrappers>
                                        {errors.maxTransactionLimit && touched.maxTransactionLimit && (
                                            <ErrorText>{errors.maxTransactionLimit}</ErrorText>
                                        )}
                                    </InputGroup>

                                    {/* <InputGroup>
                                        <Label htmlFor="mobileNo">Daily Payout Limit *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="tel"
                                                name="dailyLimit"
                                                id="dailyLimit"
                                                autoComplete="off"
                                                maxLength="10"
                                                placeholder="Enter Daily Limit number"
                                                className={errors.dailyLimit && touched.dailyLimit ? "border-red-500" : ""}
                                            />
                                        </FieldWrappers>
                                        {errors.dailyLimit && touched.dailyLimit && (
                                            <ErrorText>{errors.dailyLimit}</ErrorText>
                                        )}
                                    </InputGroup> */}
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
                )
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
export default Edit;